module.exports = __webpack_public_path__ + "img/clouds-moon.dbb4ede0.svg";